namespace Areas.Budget.List {
    "use strict";

    var tabItems = Areas.createTabsWithSameController("Budget", ["Active", "Closed"], "List");

    export function tabInitialized(params: any) {
        return Areas.tabInitialized(tabItems)(params);
    }

    export function edit() {
            gotoSelected("BudgetsGrid", "/Budget/Profile/Edit/");
    }

    export function view() {
        gotoSelected("BudgetsGrid", "/Budget/Profile/View/");
    }  

    export function columnViewLink(cellElement: any, cellInfo: any) {
        buildCellContent(cellElement,
            () => { return cellInfo.data.budgetId; },
            "<a href= '/Budget/Profile/View/{placeholder}'>View</a>");
    }



    export function showCreate() {
        const dataGrid = $('#BudgetsGrid').dxDataGrid('instance');
        const row = dataGrid.getSelectedRowsData();

        let accountId = 3080;
        let project = "Budget.01 Template";

        if (row.length == 1) {
            accountId = row[0].accountId;
            let project = row[0].projectCCNumber + " " + row[0].accountName
        } 

        const method = "GET";
        let url = `/Budget/List/CheckForBudgetAccountCategoriesForAccountId`;

        $.get(`${url}/${accountId}`,
            (data) => {
                if (data.length > 0) {
                    showCreateDialog(false, accountId, project);
                }
                else {
                   showCreateDialog(true, accountId, project);
                }

            });

    }

    function showCreateDialog(addBC: any, accountId, project) {


        const parameters = { AccountId: accountId, Project: project, AddBC: addBC };

        const createBudgetDialog = new Areas.Dialogs.CreateBudgetDialog(() => { }, parameters);

    }


    export function budgetCategories() {
        const dataGrid = $('#BudgetsGrid').dxDataGrid('instance');
        const row = dataGrid.getSelectedRowsData();

        if (row.length == 1) {
            let id = row[0].accountId;
            let linkInfo = "/Budget/BudgetAccountCategory/Index/" + id.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }

    }



}